<template>
    <div class="tab-pane fade show active" id="orders">
        <h3>Danh sách đơn hàng</h3>
        <div class="row row-padding">
            <div class="col-12">
                <v-select v-model="selectedOrderStatus" :items="order_status" item-text="name" item-value="value"
                    label="Lọc trạng thái đơn" class="input-group--focused only-mobile" @change="filter_data()"
                    clearable></v-select>
            </div>
            <div class="col-12">
                <v-select v-model="selectedOrderShipmentStatus" :items="order_shipment_status" item-text="name"
                    item-value="value" label="Lọc tình trạng đơn" class="input-group--focused only-mobile"
                    @change="filter_data()" clearable></v-select>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <mh-date-picker plabel="Từ ngày" class="input-group--focused date-picker" v-model="order_start_date"
                    @onChangeDate="order_start_date = $event; filter_data()"></mh-date-picker>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <mh-date-picker plabel="Đến ngày" class="input-group--focused date-picker" v-model="order_end_date"
                    @onChangeDate="order_end_date = $event; filter_data()"></mh-date-picker>
            </div>
        </div>
        <div class="table-responsive">
            <hpo-filter :headers="order_filter_headers" :viewName="'account_orders'" v-on:applyFilter="applyFilter"
                v-on:quickFilter="quickFilter"></hpo-filter>
            <v-data-table :headers="order_headers" :items="orders" :options.sync="pagination"
                :server-items-length="total_order" :footer-props="items_per_page" :must-sort="true" :loading="loading"
                :mobile-breakpoint="100" class="elevation-1 v-order-table free-col">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="text-start">{{ item.id }}</td>
                        <td><img :src="'/' + item.path" alt="" style="height: 56px"></td>
                        <td class="text-start">
                            <h5><a target="_blank" :href="'/chi-tiet-san-pham/' + item.product_id">{{ item.name }}</a></h5>
                            <h6>Mã sp: <b>{{ item.product_code }}</b></h6>
                            <template v-if="item.options && item.options.length > 0">
                                <ul>
                                    <li v-for="op in item.options" :key="op.order_product_id">
                                        {{ op.option_label }} (SL: {{ op.qty }})
                                    </li>
                                </ul>
                            </template>
                            <h6 v-if="item.admin_note">Admin note: <b class="text-red">{{ item.admin_note }}</b></h6>
                        </td>
                        <td class="text-end">{{ item.qty | currency }}</td>
                        <td class="text-start">{{ item.created_at | display_date }}</td>
                        <td class="text-start" v-bind:style="{ 'color': display_color(item.status, order_status) }">{{
                            item.status | display_value(order_status) }}</td>
                        <td class="text-start">{{ item.shipment_status | display_value(order_shipment_status) }}</td>
                        <td class="text-end">{{ item.total | currency }}</td>
                        <td class="text-start">{{ item.note }}</td>
                        <td class="text-center">
                            <v-icon medium class="mr-2" @click="openItem(item)"
                                :disabled="item.status != 'chua_mua_hang' && item.status != 'don_qua_han'">edit</v-icon>
                            <v-icon medium class="mr-2" @click="deleteItem(item.id)"
                                :disabled="item.status != 'chua_mua_hang' && item.status != 'don_qua_han'">delete</v-icon>
                        </td>
                    </tr>
                </template>
                <template v-slot:body.append v-if="summary_order">
                    <tr class="total-summary-td">
                        <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ summary_order.total_qty | currency }}</td>
                        <td class="text-end font-weight-bold"></td>
                        <td class="text-end font-weight-bold"></td>
                        <td class="text-end font-weight-bold"></td>
                        <td class="text-end font-weight-bold">{{ summary_order.total_amount | currency }}</td>
                        <td></td>
                    </tr>
                </template>
            </v-data-table>
        </div>
        <div class="row row-padding only-mobile" v-if="summary_order">
            <div class="col-12" style="padding-top: 20px !important;">
                <h5 class="text-red">Tổng đơn: <b>{{ total_order | currency }}</b> ----- Tổng SP: <b>{{
                    summary_order.total_qty | currency }}</b> ----- Tổng tiền: <b>{{ summary_order.total_amount |
        currency }}</b></h5>
            </div>
        </div>
        <v-list class="v-list-order">
            <v-list-item v-for="(item, index) in orders" :key="index">
                <v-list-item-content>
                    <div class="row">
                        <div class="col-12">
                            <span>{{ item.created_at | display_date }}</span>
                        </div>
                        <div class="col-4">
                            <img :src="'/' + item.path" alt="">
                        </div>
                        <div class="col-8">
                            <p>Mã đơn hàng: <b>{{ item.id }}</b></p>
                            <p>Mã sản phẩm: <b>{{ item.product_code }}</b></p>
                            <p>Tên sản phẩm: <b>{{ item.name }}</b></p>
                        </div>
                        <div class="col-12">
                            <p>Ghi chú: <b class="text-red">{{ item.note }}</b></p>
                            <p>Admin note: <b>{{ item.admin_note }}</b></p>
                        </div>
                        <div class="col-12">
                            <p>Trạng thái: <b v-bind:style="{ 'color': display_color(item.status, order_status) }">{{
                                item.status | display_value(order_status) }}</b></p>
                            <p>Giao hàng: <b>{{ item.shipment_status | display_value(order_shipment_status) }}</b></p>
                        </div>
                        <div class="col-12">
                            <p>Thuộc tính:</p>
                            <template v-if="item.options && item.options.length > 0">
                                <ul>
                                    <li v-for="op in item.options" :key="op.order_product_id">
                                        {{ op.option_label }} (SL: {{ op.qty }})
                                    </li>
                                </ul>
                            </template>
                            <p>Thành tiền: <b class="text-red">{{ item.total | currency }}</b></p>
                        </div>
                        <div class="col-12 text-right">
                            <v-icon medium @click="deleteItem(item.id)"
                                :disabled="item.status != 'chua_mua_hang' && item.status != 'don_qua_han'">delete</v-icon>
                        </div>
                        <div class="col-12">
                            <hr />
                        </div>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <div class="row only-mobile" v-bind:style="{ display: showLoadMoreOrder ? 'block !important' : 'none !important' }">
            <div class="col-12" style="text-align: center;">
                <button type="submit" class="btn-hcs" @click="load_more_order()">Xem thêm</button>
            </div>
        </div>
        <v-dialog v-model="dialogItem" max-width="700px">
            <v-card v-if="selectedItem">
                <v-card-title>
                <span class="title">Cập nhật đơn hàng #{{ selectedItem.id }}</span>
                </v-card-title>
                <v-card-text>
                <v-container grid-list-md pa-0 v-if="selectedItem.product_detail">
                    <p>Sản phẩm: <b>{{ selectedItem.product_detail.name }}</b></p>
                    <p>Mã sp: <b>{{ selectedItem.product_detail.product_code }}</b></p>
                    <div class="product_option" v-if="selectedItem.product_detail.options && selectedItem.product_detail.options.length > 0">
                        <v-layout row wrap v-for="(op, op_index) in selectedItem.product_detail.options" :key="op_index">
                            <v-flex lg4 md4 sm12>
                                <h4>{{ op.name }}</h4>
                            </v-flex>
                            <v-flex lg8 md8 sm12 v-if="op.position == 0">
                                <ul class="list-inline-1">
                                    <li v-for="(val, val_index) in op.option_values" :key="val_index" v-bind:class="{ 'has_image': op.has_image && val.path, 'active': val.id == selectedFirstOption.id, 'choised': getFirstOptionQty(val.id) > 0}"  @click="selectedFirstOption = val">
                                        <p>{{ val.label }}</p>
                                    </li>
                                </ul>
                            </v-flex>
                            <v-flex lg8 md8 sm12 v-else>
                                <ul class="list-inline-2">
                                    <li v-for="val in op.option_values" :key="val.id" class="number-picker" v-bind:class="{'choised': getOrderOption(selectedFirstOption.id, val.id) > 0}">
                                        <label for="qty">{{ (selectedFirstOption ? selectedFirstOption.label + ' - ' : '') + val.label }}</label>
                                        <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, val.id)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, val.option_id, val.id, event)"></v-minusplusfield>
                                    </li>
                                </ul>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="selectedItem.product_detail.options.length == 1 && selectedFirstOption">
                            <v-flex lg4 md4 sm12>
                            </v-flex>
                            <v-flex lg8 md8 sm12>
                                <ul class="list-inline-2">
                                    <li class="number-picker single">
                                        <label for="qty">{{ selectedFirstOption.label }}</label>
                                        <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, 0)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, 0, 0, event)"></v-minusplusfield>
                                    </li>
                                </ul>
                            </v-flex>
                        </v-layout>
                    </div>
                    <v-minusplusfield v-else :min="0" :max="1000000" :value="getOrderOption(0, 0)" @input="event => updateOrderOption(0, 0, 0, 0, event)"></v-minusplusfield>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="editItem">Cập nhật</v-btn>
                <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import Filtering from "@/components/Filtering";
import _ from 'lodash';
import { display_color } from "@/commons/formater";
import { sendErrorNotice, pad } from '@/commons/utils'
import MHDatePicker from "@/components/daterange/MHDatePicker";
import PlusMinusField from "@/components/PlusMinusField.vue";
export default {
    components: {
        "hpo-filter": Filtering,
        'v-minusplusfield': PlusMinusField,
        "mh-date-picker": MHDatePicker
    },
    data () {
        return {
            viewName: "account_orders",
            selectedFirstOption: {},
            order_options: [],
            pad: pad,
            display_color: display_color,
            order_headers: [
                {
                    text: "ID",
                    value: "orders.id",
                    width: "60px",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ảnh",
                    value: "path",
                    width: "60px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Sản phẩm",
                    value: "product_code",
                    align: 'start',
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Số lượng",
                    value: "qty",
                    align: "end",
                    width: "60px",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày lên đơn",
                    value: "orders.created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Trạng thái",
                    value: "status",
                    filterable: true,
                    values: configs.ORDER_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Tình trạng",
                    value: "shipment_status",
                    filterable: true,
                    values: configs.ORDER_SHIPMENT_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "orders.note",
                    align: 'start',
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "",
                    value: "",
                    width: "60px",
                }
            ],
            order_status: configs.ORDER_STATUS,
            order_shipment_status: configs.ORDER_SHIPMENT_STATUS,
            pagination: {...configs.PAGINATION, itemsPerPage: 10},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: [],
            selectedItem: null,
            dialogItem: false,
            selectedOrderStatus: '',
            selectedOrderShipmentStatus: '',
            order_start_date: '',
            order_end_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        }
    },
    computed: {
        ...mapState({
            customer: (state) => state.users.selected,
            orders: state => state.orders.all.data,
            total_order: state => state.orders.all.total,
            summary_order: state => state.orders.all.summary,
            loading: state => state.orders.loading
        }),
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
        showLoadMoreOrder() {
            return (!this.orders || this.total_order > this.orders.length) && this.isMobile();
        },
        order_filter_headers() {
            let tmp = [...this.order_headers];
            tmp.push({
                    text: "Tên sản phẩm",
                    value: "name",
                    align: 'start',
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },);
            return tmp;
        }
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                if(this.isMobile()) return;
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions['account_orders'] : []
                this.filter_data();
            },
            deep: true
        }
    },
    methods: {
        isMobile() {
            if( screen.width <= 760 ) {
                return true;
            }
            else {
                return false;
            }
        },
        refresh_data() {
            this.filter_data();
        },
        filter_data(lazyload = false) {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            if(this.selectedOrderStatus) {
                param.filter.push({
                    column: "status",
                    value: this.selectedOrderStatus,
                    condition: "s_equal",
                });
            }
            if(this.selectedOrderShipmentStatus) {
                param.filter.push({
                    column: "shipment_status",
                    value: this.selectedOrderShipmentStatus,
                    condition: "s_equal",
                });
            }
            if(this.order_start_date) {
                param.filter.push({
                    column: "created_at",
                    value: this.order_start_date,
                    condition: "d_greater_than_or_equal",
                });
            }
            if(this.order_end_date) {
                param.filter.push({
                    column: "created_at",
                    value: this.order_end_date,
                    condition: "d_less_than_or_equal",
                });
            }
            if(!lazyload) {
                if(this.isMobile()) {
                    param.pagination.page = 1;
                }
                this.$store.dispatch("orders/getList", param);
            }
            else {
                param.lazyload = true;
                param.pagination.itemsPerPage = 30;
                this.$store.dispatch("orders/getList", param);
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        deleteItem(id) {
            this.$store.dispatch("orders/getDetail", id).then((ret) => {
                if (ret && (ret.status == 'chua_mua_hang' || ret.status == 'don_qua_han')) {
                    this.$root.$emit('REQUEST_DELETE_DATA', id);
                }
                else {
                    sendErrorNotice('Không thể huỷ đơn hàng.');
                    this.refresh_data();
                }
            });
        },
        openItem: function (item) {
            this.order_options = [];
            this.$store.dispatch("orders/getDetail", item.id).then((ret) => {
                if (ret) {
                    this.selectedItem = ret;
                    this.selectedFirstOption = this.selectedItem.product_detail.options && this.selectedItem.product_detail.options.length > 0 ? this.selectedItem.product_detail.options[0].option_values[0] : {};
                    for (let i = 0; i < this.selectedItem.options.length; i++) {
                        const element = this.selectedItem.options[i];
                        let ops = element['option_id'] ? element['option_id'].split(',') : []
                        let vals = element['option_value_id'] ? element['option_value_id'].split(',') : []
                        this.order_options.push({
                            'id': element.id,
                            'product_id': this.selectedItem.product_detail.id,
                            'order_id': this.selectedItem.id,
                            'price': this.selectedItem.product_detail.price,
                            'first_op_id': ops.length > 0 ? Number(ops[0]) : 0, 
                            'first_id': vals.length > 0 ? Number(vals[0]) : 0, 
                            'last_op_id': ops.length > 1 ? Number(ops[1]) : 0, 
                            'last_id': vals.length > 1 ? Number(vals[1]) : 0, 
                            'qty': Number(element['qty']) 
                        });
                    }
                    this.dialogItem = true;
                }
            });
        },
        editItem() {
            this.$store.dispatch("orders/setDetail", {data: {id: this.selectedItem.id, options: this.order_options, action: 'update_options'}, id: this.selectedItem.id});
            this.dialogItem = false;
        },
        getNextOrder() {
            if (this.isMobile()) {
                this.filter_data(true);
            }
        },
        load_more_order() {
            this.pagination.page = this.pagination.page + 1;
            if(!this.orders || this.total_order > this.orders.length) {
                this.filter_data(true);
            }
        },
        updateOrderOption(first_op_id, first_opvl_id, last_op_id, last_opvl_id, value) {
            let item = _.find(this.order_options, {'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id });
            if (item) {
                item['qty'] = Number(value);
            }
            else {
                this.order_options.push({'product_id': this.selectedItem.product_detail.id, 'order_id': this.selectedItem.id, 'price': this.selectedItem.product_detail.price, 'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id , 'qty': Number(value) });
            }
        },
        getOrderOption(first_id, last_id) {
            let item = _.find(this.order_options, {'first_id': first_id, 'last_id': last_id });
            return item ? item.qty : 0;
        },
        getFirstOptionQty(first_id) {
            return _.sumBy(this.order_options, (p) => {return p.first_id == first_id ? p.qty : 0});
        },
    },
    mounted () {
        this.$store.commit("orders/setList", {data: [], total: 0});
        this.getNextOrder();
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("orders/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>